<template>
  <div id="preventPollution">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>渠道政策</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/ChannelPolicy/pricePublic' }">售价公示</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/productInformation?' + 'f=' + this.$route.query.newname + '&e=' + this.$route.query.newid }">{{this.$route.query.newname}}</el-breadcrumb-item>
        <!-- <el-breadcrumb-item :to="{ path: '/productInformation?' + 'f=' + this.$route.query.newname + '&e=' + this.$route.query.newid }">{{this.$route.query.name}}</el-breadcrumb-item> -->
        <el-breadcrumb-item>变更历史</el-breadcrumb-item>
      </el-breadcrumb>
    <div class="page2">
      <div class="block">
        <span class="demonstration" style="margin-right: 10px;">变更时间</span>
        <el-date-picker
          v-model="searchformDate"
          value-format="yyyy-MM-dd"
          size="small"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          range-separator="~"
          :picker-options="pickerOptions"
          @change="oneStep">
        </el-date-picker>
      </div>

      <el-timeline style="margin-left: 26px;margin-top: 35px;">
        <el-timeline-item v-for="(item,i) in tableData" :key="i" :timestamp="item.changetime|fullTime" placement="top">
            <p class="title">变更人：{{item.realname}}</p>
            <el-card>
                <div class="list">
                  <p>
                    <span :class="item.changeMessage=='设置表格'?'set':item.changeMessage=='删除'?'del':'modifi'" v-if="item.changetype !=2">{{item.changeMessage}}</span>
                  </p>
                  <p v-if="item.contentBefore && item.changetype == 2">
                    <span class="before">变更前</span>
                    {{item.contentBefore}}
                  </p>
                  <p v-if="item.contentBefore && item.changetype != 2">
                    {{item.contentBefore}}
                  </p>
                  <p v-if="item.contentAfter && item.changetype == 2">
                    <span class="after">变更后</span>
                    {{item.contentAfter}}
                  </p>
                  <p v-if="item.contentAfter && item.changetype != 2">
                    {{item.contentAfter}}
                  </p>
                </div>
            </el-card>
        </el-timeline-item>
      </el-timeline>
      <div style="width: 100%;text-align: center;">
        <el-button v-show="loadMore" @click="loadMoreBtn" plain>加载更多</el-button>
      </div>
      <div class="nodata" v-if="tableData.length == 0"><img src="@/assets/img/other/nodata.svg">暂无数据</div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageNum: 1,
        pageSize: 10,
        tableData: [],
        searchformDate: [],
        pickerOptions: {
          shortcuts: [
            {
              text: '今日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                picker.$emit('pick', [start, start]);
              }
            },{
              text: '近7日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '近15日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
                picker.$emit('pick', [start, end]);
              }
            },{
              text: '近30日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                picker.$emit('pick', [start, end]);
              }
            },{
              text: "近90日",
              onClick: picker => {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
                picker.$emit('pick', [start, end]);
              }
            }, {
              text: '近365日',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 364);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },
        loadMore: false,
      }
    },
    filters: {
      formatDate: function (value) {
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
    },
    mounted() {
      this.oneStep();
    },
    methods: {
      loadMoreBtn() {
        this.pageNum++
        this.oneStep(this.pageNum)
      },
      oneStep() {
        let params={
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          modulename: 'Product',
          objectid: this.$route.query.id,
          isall: ''
        }
        if (this.$options.filters['fullTime'] (this.searchformDate[0]) == 'NaN-NaN-NaN NaN:NaN:NaN') {
          params.begintime = ''
        } else {
          params.begintime = this.$options.filters['fullTime'] (this.searchformDate[0])
        }
        if (this.$options.filters['fullTime'] (this.searchformDate[1]) == 'NaN-NaN-NaN NaN:NaN:NaN') {
          params.endtime = ''
        } else {
          params.endtime = this.$options.filters['fullTime'] (this.searchformDate[1])
        }
        fetch({
          url: "hcm/hcmChangeHistory/getList",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data;
            if (this.tableData.length == 10) {
              this.loadMore = true
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(err => {
          this.$message.error('服务器出错');
        })
      },

    }
  }
</script>
<style scoped lang="scss">
  .page {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .page2 {
    padding: 20px;
    margin: 20px;
    background-color: white;
  }
  .list{
    display: inline-block;
    width: calc(100% - 100px);
    span{
      padding: 0 10px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
      font-size: 13px;
      margin-right: 10px;
      &.before{
        background: #fff2d9;
        color: #faad14;
      }
      &.after{
        background-color: #e9f5ff;
        color: #108cee;
      }
      &.set{
          background-color: #FFFBF3;
          color: #FAB332;
      }
      &.modifi{
          background-color: #FDF7E9;
          color: #BDA571;
      }
      &.del{
          background-color:#FEF4F5;
          color: #E90E24;
      }
    }
  }
</style>
<style lang="scss">
#preventPollution {
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-dialog__header {
    padding: 20px 20px 10px;
    border-bottom: 1px solid #d9d9d9;
  }
  .el-card__body {
    display: flex;
  }
  .el-button {
    width: 420px;
    border: 1px dashed #DCDFE6;
  }
}
</style>
